import ProgramNutritionForm from './form'
import { getRecipeTagOptionDetail } from 'api/RecipeTag'
import React, { useState, useLayoutEffect } from 'react'

export default function (props) {
  const [data, setData] = useState({})
  const { match: { params: { id } } } = props

  useLayoutEffect(() => {
    getRecipeTagOptionDetail(id).then(setData)
  }, [id])

  return <ProgramNutritionForm { ...props } data={data} />
}
